var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-form-select" }, [
    _c(
      "label",
      {
        staticClass: "c-form-select__label",
        class: _vm.requiredCssClass,
        attrs: { for: _vm.id }
      },
      [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "select",
      _vm._b(
        {
          staticClass: "c-form-select__control",
          attrs: { "aria-describedby": _vm.errorId, id: _vm.id },
          domProps: { value: _vm.value },
          on: { change: _vm.updateValue }
        },
        "select",
        _vm.$attrs,
        false
      ),
      [
        _c("option", { attrs: { value: "" } }, [
          _vm._v("Please select an option")
        ]),
        _vm._v(" "),
        _vm._l(_vm.options, function(option) {
          return _c(
            "option",
            {
              key: option.value,
              domProps: {
                selected: option.value === _vm.value,
                value: option.value
              }
            },
            [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.validationError
      ? _c(
          "span",
          {
            staticClass: "c-form-input__validation-message",
            attrs: { id: _vm.errorId }
          },
          [_vm._v("\n    " + _vm._s(_vm.validationMessage) + "\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcded248", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcded248","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/geneco/resources/form/elements/FormSelect.vue
// module id = 569
// module chunks = 0